var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.tests,
          columns: _vm.columns_tests,
          "row-key": "id",
          pagination: _vm.pagination_tests,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination_tests = $event
          },
          request: _vm.requestTests
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c("q-td", { key: "title", attrs: { props: props } }, [
                      props.row.title.length > 49
                        ? _c(
                            "span",
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    props.row.title.substring(0, 50) + "..."
                                  ) +
                                  "\n                        "
                              ),
                              _c("q-tooltip", [_vm._v(_vm._s(props.row.title))])
                            ],
                            1
                          )
                        : _c("span", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(props.row.title) +
                                "\n                    "
                            )
                          ])
                    ]),
                    _c(
                      "q-td",
                      { key: "qty_questions", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(props.row.qty_questions) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "qty_user_results", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(props.row.qty_user_results) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "status",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _c(
                          "q-chip",
                          {
                            staticClass: "full-width text-center",
                            attrs: {
                              small: "",
                              icon: _vm.getIconStatusTest(props.row.status),
                              color: _vm.getColorStatusTest(props.row.status)
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.getTextStatusTest(props.row.status)
                                  )
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      {
                        key: "actions",
                        attrs: { "auto-width": "", props: props }
                      },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "secondary",
                              icon: "fas fa-users"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showTestUsers(props.row)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("participants_report_tooltip")
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_test_users,
            callback: function($$v) {
              _vm.show_test_users = $$v
            },
            expression: "show_test_users"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_test_users = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.test.title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    ref: "table",
                    staticClass: "q-mt-lg",
                    attrs: {
                      data: _vm.users,
                      columns: _vm.columns_users,
                      "row-key": "user_id",
                      pagination: _vm.pagination_users,
                      loading: _vm.loading,
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      filter: _vm.filter_users,
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.pagination_users = $event
                      },
                      request: _vm.requestUserTests
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              attrs: {
                                icon: "fas fa-search",
                                placeholder: _vm.$t("search"),
                                debounce: 500
                              },
                              model: {
                                value: _vm.filter_users,
                                callback: function($$v) {
                                  _vm.filter_users = $$v
                                },
                                expression: "filter_users"
                              }
                            }),
                            _c("div", { staticClass: "col" }),
                            _c("q-btn", {
                              staticClass: "q-mr-sm",
                              attrs: {
                                color: "secondary",
                                icon: "fas fa-download",
                                label: _vm.$t("evaluation_report")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.downloadReport()
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n                        "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return [
                            _c(
                              "q-tr",
                              {
                                staticClass: "cursor-pointer",
                                attrs: { props: props },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.showTestUsersResult(props.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-td",
                                  { key: "full_name", attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(props.row.full_name) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  { key: "email", attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(props.row.email) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "result_date",
                                    attrs: { props: props }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.fDate(props.row.result_date)
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_test_results,
            callback: function($$v) {
              _vm.show_test_results = $$v
            },
            expression: "show_test_results"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_test_results = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.test.title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end question-list" },
                  _vm._l(_vm.test_results, function(question, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "q-subheading text-weight-medium q-mb-xs",
                            attrs: { id: "qt" + question.id }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(index + 1) +
                                ") " +
                                _vm._s(question.question) +
                                "\n                        "
                            )
                          ]
                        ),
                        _c("p", [_vm._v(_vm._s(question.answer))])
                      ]
                    )
                  }),
                  0
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }